import { withVariants } from '@hvccc/component-library';
import Stacked from './Stacked';

const styles = {
  stacked: Stacked,
};

export default withVariants(styles)(Stacked);
